import { memo } from "react";

import AppAuthLayoutDto from "dto/components/pages/authenticate/app-auth-layout-dto";

import loginImage from "assets/images/pages/authenticate/login.png";

const AppAuthLayout = ({ children }: AppAuthLayoutDto) => {
	return (
		<div className="app-auth-layout">
			<div className="auth-layout">
				<div className="auth-layout__illustration">
					<img src={loginImage} alt="Login" />
				</div>

				<div className="auth-layout__item">{children}</div>
			</div>
		</div>
	);
};

export default memo(AppAuthLayout);
